import { render, staticRenderFns } from "./ktomIndexAll.vue?vue&type=template&id=39f1baff&scoped=true&"
import script from "./ktomIndexAll.vue?vue&type=script&lang=js&"
export * from "./ktomIndexAll.vue?vue&type=script&lang=js&"
import style0 from "./ktomIndexAll.vue?vue&type=style&index=0&id=39f1baff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f1baff",
  null
  
)

export default component.exports